import * as React from 'react';

import LearnerProgramHomeBottom from 'bundles/enterprise-admin-grow-with-google/components/learner/LearnerProgramHomeBottom';

const GoogleProgramFooterModuleNotConfigurable = () => {
  return <LearnerProgramHomeBottom />;
};

export default GoogleProgramFooterModuleNotConfigurable;
